<p-toast position="bottom-center"></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="page-title">
  <div class="page-title-text">
    <h3>Fleet Management</h3>
  </div>

  <div class="desktop-actions">
    <button *ngIf="canDeploy" pButton type="button" [disabled]="!isDeploySoftwareEnabled" (click)="onDeploySoftware()"
      [class]="isDeploySoftwareEnabled ? 'selected' : 'deploy-disabled'"
      [pTooltip]="!isDeploySoftwareEnabled ? deployDisabledTooltip : undefined"
      tooltipPosition="bottom" [style.cursor]="!isDeploySoftwareEnabled ? 'default' : 'pointer'">
      <i class="pi pi-download" style="margin-right: 0.5rem;"></i>
      Deploy Software
    </button>

    <div style="display: flex; gap: 1rem;">
      <button pButton type="button" (click)="refreshMachineList()" [disabled]="loading" class="p-button-outlined">
        <ng-container *ngIf="!loading">
          <i class="pi pi-refresh"></i>
        </ng-container>
        <ng-container *ngIf="loading">
          <p-progressSpinner styleClass="custom-spinner" strokeWidth="4" fill="#ffffff" animationDuration="1s"
            [style]="{width: '16px', height: '16px', 'margin': 'initial'}"></p-progressSpinner>
        </ng-container>
      </button>
    </div>
  </div>


  <div class="mobile-actions">
    <p-button #mobileMenuButton icon="pi pi-bars" [text]="true" (click)="mobileMenu.toggle($event)"
      (keydown.enter)="mobileMenu.toggle($event)" styleClass="mobile-menu-button" />
    <p-menu #mobileMenu [model]="mobileMenuItems" [popup]="true" appendTo="body" />
  </div>

</div>

<p-card [ngStyle]="{'padding': '0'}">
  <div style="display: flex; justify-content: flex-start; align-items: center; gap: 1rem; padding: 14px 0 0 0;">
    <p-button icon="pi pi-filter-slash" label="Clear" [text]="true" (click)="clearFilters()" pTooltip="Clear filters"
      tooltipPosition="top" class="clear-filters-button" [ngStyle]="{'color': '#dc582e', 'font-size': '1rem'}" />
  </div>

  <app-besharp-table #beSharpTable [tableItems]="datasource" [totalRecords]="datasourceLength" [lazyMode]="true"
    [loading]="loadingAssigned" [debounceSearchTime]="300" [idColumnDef]="'id'" [tableDefinitions]="tableDefinition"
    [globalFilterFields]="globalFilterFields" [actionDefinitions]="actionDefinition" [actionTitle]="''"
    [tableSize]="eBesharpTableSize.Small" [defaultActive]="'id'" [defaultDirection]="-1" [paginator]="true"
    [pageRows]="pageSize" [pageRowsOptions]="[5, 10, 20]" [showCurrentPageReport]="true" [showSearchInput]="false"
    [showClearFiltersButton]="false" [showExportButton]="false" [showStripes]="true" [showGridLines]="false"
    [hasCheckboxes]="canDeploy" [maxSelectable]="maxMachinesLimit" [rowOverEffect]="true"
    (rowsSelectionChangedEvent)="rowSelectionEvent($event)" (selectionLimitReached)="onSelectionLimitReached($event)"
    (onPageChange)="onPageChange($event)" (onClearFilters)="clearFilters()"
    (onColumnFilter)="onColumnFilterChange($event)" />
</p-card>

<p-dialog header="Deploy Software" [(visible)]="showDeployModal" [modal]="true" [closable]="!isDeploying"
  [style]="{width: '600px'}" [draggable]="false" [resizable]="false">
  <div class="deploy-modal-content">
    <div class="deploy-info">
      <h4>Deployment Details</h4>
      <p><strong>Selected Machines:</strong>
        <span *ngIf="selectedMachines.length > 0">
          <span *ngFor="let machine of selectedMachines; let i = index">
            {{machine.serialNumber}}<span *ngIf="i < selectedMachines.length - 1">, </span>
          </span>
        </span>
        <span *ngIf="selectedMachines.length === 0">No machines selected</span>
      </p>
      <p><strong>Model:</strong> {{selectedMachines.length > 0 ? getSelectedModelsDisplay() : 'N/A'}}</p>
    </div>

    <form [formGroup]="deployForm" style="width: 100%">
      <div class="form-group" style="margin-bottom: 1rem;" *ngIf="!isMenderDeploy">
        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.25rem;">
          <label for="softwareVersionId">Software Version</label>
          <p-progressSpinner *ngIf="loadingSoftwareList"
            [style]="{'width': '16px', 'height': '16px', 'margin': '0', 'position': 'relative', 'top': '-4px'}"
            strokeWidth="4" />
        </div>
        <p-select id="softwareVersionId" [options]="softwareVersionOptions" formControlName="softwareVersionId"
          placeholder="Select software version" styleClass="w-full" style="font-size: 14px !important; width: 100%"
          [filter]="true" filterPlaceholder="Search version..." />
      </div>

      <div class="form-group" style="margin-bottom: 1rem;" *ngIf="isMenderDeploy">
        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.25rem;">
          <label for="artifactSelector">Mender Artifact</label>
          <p-progressSpinner 
            *ngIf="loadingArtifacts"
            [style]="{'width': '16px', 'height': '16px', 'margin': '0', 'position': 'relative', 'top': '-4px'}"
            strokeWidth="4"
          />
        </div>
        <p-select
          *ngIf="!loadingArtifacts && !artifactLoadError && menderArtifacts.length > 0"
          id="artifactSelector"
          [options]="getArtifactOptions()"
          [(ngModel)]="selectedArtifactName"
          [ngModelOptions]="{standalone: true}"
          optionLabel="label"
          optionValue="value"
          placeholder="Select artifact"
          [filter]="true"
          filterPlaceholder="Search artifact..."
          styleClass="w-full"
          style="font-size: 14px !important; width: 100%"
          (onScrollEnd)="onArtifactScrollEnd()"
        >
          <ng-template pTemplate="footer" *ngIf="hasMoreArtifacts">
            <div style="padding: 0.5rem; text-align: center; font-size: 0.8rem; color: var(--text-color-secondary);">
              <i class="pi pi-spin pi-spinner" style="margin-right: 0.3rem;"></i> Loading more...
            </div>
          </ng-template>
        </p-select>
        <div *ngIf="!loadingArtifacts && !artifactLoadError && menderArtifacts.length === 0" style="color: var(--text-color-secondary); font-style: italic; padding: 0.5rem 0;">
          No artifacts available
        </div>
        <div *ngIf="artifactLoadError" style="display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0;">
          <span style="color: var(--red-500);">Failed to load artifacts</span>
          <button 
            pButton 
            type="button" 
            icon="pi pi-refresh" 
            label="Reload"
            class="p-button-text p-button-sm"
            (click)="retryLoadArtifacts()"
          ></button>
        </div>
      </div>

      <div class="form-group" style="margin-bottom: 1rem;" *ngIf="isMenderDeploy">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <p-checkbox [(ngModel)]="menderForceInstallation" [ngModelOptions]="{standalone: true}"
            inputId="forceInstallToggle" [binary]="true" />
          <label for="forceInstallToggle" style="cursor: pointer; margin: 0;">
            Force installation
          </label>
          <i class="pi pi-question-circle"
            pTooltip="Forces the device to reinstall the artifact even if it is already installed (overrides the 'already-installed' check)"
            tooltipPosition="top"
            style="color: #888; font-size: 0.9rem; cursor: help;"></i>
        </div>
      </div>

      <div class="form-group" style="margin-bottom: 1rem;" *ngIf="!isMenderDeploy">
        <label for="updateMode">Forced Update</label>
        <input id="updateMode" type="text" formControlName="updateMode" placeholder="-" readonly
          class="p-inputtext p-component" style="width: 100%; padding: 0.5rem; border-radius: 4px;" />
      </div>

      <div class="form-group" style="margin-bottom: 1rem;">
        <label for="deploymentNotes">Notes</label>
        <textarea id="deploymentNotes" formControlName="deploymentNotes" placeholder="Enter deployment notes (optional)"
          rows="4" class="p-inputtext p-component" style="width: 100%; resize: vertical;"></textarea>
      </div>

      <div class="form-group" style="margin-bottom: 1rem;">
        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
          <p-checkbox [(ngModel)]="isScheduled" [ngModelOptions]="{standalone: true}" inputId="scheduleToggle"
            [binary]="true" />
          <label for="scheduleToggle" style="cursor: pointer; margin: 0;">Schedule deployment</label>
        </div>
        <div *ngIf="isScheduled" style="margin-top: 0.25rem;">
          <label for="scheduledAt" style="display: block; margin-bottom: 0.25rem;">Date &amp; Time (max 48h)</label>
          <p-datepicker id="scheduledAt" formControlName="scheduledAt" [showTime]="true" [hourFormat]="'24'"
            [minDate]="minScheduledDate" [maxDate]="maxScheduledDate" [showIcon]="true" [hideOnDateTimeSelect]="false"
            placeholder="Select date and time" styleClass="w-full" style="width: 100%" />
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="deploy-modal-footer">
      <p-button [label]="isScheduled ? 'Schedule' : 'Deploy'" [icon]="isScheduled ? 'pi pi-calendar' : 'pi pi-download'"
        (onClick)="onConfirmDeploy()" [loading]="isDeploying" [disabled]="!isDeployFormValid() || isDeploying"
        severity="success" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="Machine Details" [(visible)]="showDetailsModal" [modal]="true" [closable]="true"
  [style]="{width: '640px'}" [draggable]="false" [resizable]="false" styleClass="details-dialog">
  <div class="details-loader" *ngIf="loadingDetails">
    <p-progressSpinner strokeWidth="4" animationDuration="1s"
      [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
    <span>Loading details...</span>
  </div>

  <div class="machine-details-modal-content" *ngIf="!loadingDetails && machineDetails">

    <div class="details-status-row">
      <span class="badge" [ngClass]="machineDetails.isConnected ? 'connected-badge' : 'disconnected-badge'">
        {{ machineDetails.isConnected ? 'Connected' : 'Disconnected' }}
      </span>
      <span class="badge" [ngClass]="machineDetails.isConnectable ? 'connectable-badge' : 'not-connectable-badge'">
        {{ machineDetails.isConnectable ? 'Connectable' : 'Not Connectable' }}
      </span>
      <span class="badge alarm-badge" *ngIf="machineDetails.hasAlarm">Has Alarm</span>
      <span class="badge updating-badge" *ngIf="machineDetails.isInUpdateMode">Updating</span>
    </div>

    <div class="details-grid">
      <div class="detail-item">
        <span class="detail-label">Serial</span>
        <span class="detail-value">{{ machineDetails.serialNumber }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Name</span>
        <span class="detail-value">{{ machineDetails.name || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">
          Family
          <i *ngIf="machineDetails.family?.toLowerCase() === 'unsupported' && machineDetails.familyAic"
            class="pi pi-question-circle detail-hint-icon" pTooltip="Family taken from AIC" tooltipPosition="top">
          </i>
        </span>
        <span class="detail-value">
          {{ (machineDetails.family?.toLowerCase() === 'unsupported' ? machineDetails.familyAic : machineDetails.family)
          || '-' }}
        </span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Model</span>
        <span class="detail-value">{{ machineDetails.familyAic || '-' }}</span>
      </div>
    </div>

    <div class="details-divider"></div>

    <div class="details-grid">
      <div class="detail-item">
        <span class="detail-label">SW Version</span>
        <span class="detail-value">{{ machineDetails.softwareVersionNumber || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">SW Package</span>
        <span class="detail-value">{{ machineDetails.packageSwVersion || '-' }}</span>
      </div>
    </div>

    <div class="details-divider"></div>

    <div class="details-grid">
      <div class="detail-item">
        <span class="detail-label">Customer</span>
        <span class="detail-value">{{ machineDetails.customerName || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Customer Group</span>
        <span class="detail-value">{{ machineDetails.customerGroup || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Router</span>
        <span class="detail-value">{{ machineDetails.router || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">SIM ID</span>
        <span class="detail-value">{{ machineDetails.simId || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Last Connected</span>
        <span class="detail-value">{{ machineDetails.lastConnected || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Position</span>
        <span class="detail-value">{{ machineDetails.positionLat || '-' }}, {{ machineDetails.positionLon || '-'
          }}</span>
      </div>
    </div>

    <div class="details-divider"></div>

    <div class="details-section" *ngIf="!machineDetails.isConnected && !machineDetails.isInUpdateMode">
      <div class="details-section-title">Component Versions</div>
      <div class="details-empty-state">
        <i class="pi pi-wifi" style="font-size: 1.5rem; opacity: 0.4"></i>
        <span>Machine is offline or can't connect — component data unavailable</span>
      </div>
    </div>

    <div class="details-section" *ngIf="machineDetails.isInUpdateMode && !machineDetails.isConnected">
      <div class="details-section-title">Component Versions</div>
      <div class="details-empty-state updating">
        <i class="pi pi-spin pi-sync" style="font-size: 1.5rem"></i>
        <span>Machine is currently updating — component data unavailable</span>
      </div>
    </div>

    <div class="details-section" *ngIf="machineDetails.components?.length > 0">
      <div class="details-section-title">Component Versions</div>
      <table class="components-table">
        <thead>
          <tr>
            <th>Component</th>
            <th>App Version</th>
            <th>App Date</th>
            <th>Boot Version</th>
            <th>Boot Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let comp of machineDetails.components">
            <td><strong>{{ comp.component }}</strong></td>
            <td>{{ comp.app?.version || '-' }}</td>
            <td>{{ comp.app?.date || '-' }}</td>
            <td>{{ comp.boot?.version || '-' }}</td>
            <td>{{ comp.boot?.date || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" [text]="true" (onClick)="closeDetailsModal()" />
  </ng-template>
</p-dialog>